
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotel-search",
      function () {
        return require("private-next-pages/hotel-search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hotel-search"])
      });
    }
  